import Model from '@/models/Model'

export default class GBranchOffice extends Model {
  reset() {
    //
    this.branch_office_sii = this.sii_barnch_office_sii || ''
    //
    return this
  }
  resource() {
    return 'g_branch_office'
  }
  toCreate() {
    return this.clean([
      'address',
      'branch_office_sii',
      'email',
      'g_commune_id',
      'name',
      'phone',
    ])
  }
  toUpdate() {
    return this.clean([
      'address',
      'branch_office_sii',
      'email',
      'g_commune_id',
      'id',
      'name',
      'phone',
    ])
  }
}